"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ratingIconByDisplayFormat = exports.ratingDisplayFormats = void 0;
exports.ratingDisplayFormats = [
    "star",
    "heart",
    "smiley",
    "flag",
    "thumb_up",
    "numbers",
    "rectangles",
];
exports.ratingIconByDisplayFormat = {
    star: "star-fav",
    heart: "heart",
    smiley: "smiley",
    flag: "flag",
    thumb_up: "thumb-up",
    numbers: "numbers",
    rectangles: "rectangles",
};
